// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/clinic-reimbursement/components/clinic-reimbursement-header/clinic-reimbursement-header.less
// module id = 3890
// module chunks = 0